import { Location } from '@angular/common';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { AssignAgentsComponent } from '@app/pages/common/assign-agents/assign-agents.component';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-skill-details',
  templateUrl: './skill-details.component.html',
  styleUrls: ['./skill-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SkillDetailsComponent {
  @ViewChild(AssignAgentsComponent)
  private assignAgentComponent!: AssignAgentsComponent;

  details: any;
  skillDetail: any;
  title: string = '';
  agentList: any;

  owner = 'skill';
  object = 'agent';
  priorities = true;
  persistence = true;
  roles = false;
  disable = undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private location: Location
  ) {
    this.route.params.subscribe((params: any) => {
     // console.log(params);
      //  alert(params.id)
      this.loadSkillDetails(params.id);
      //this.loadSkillAgents(params.id)
    });

    const urlArray: any = this.router.url.split('/');
    urlArray.shift();
    if (urlArray.length > 0) {
      for (let i = 0; i < urlArray.length - 1; i++) {
        this.currentpath += urlArray[i] + (urlArray[i + 2] ? '>' : '');
      }
    }
  }
  currentpath: any = '';

  loadSkillDetails(id: number) {
    this.managerService
      .GetSkillByID(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetSkillByID');
          if (isValid) {
            this.skillDetail = data.Response.Data;
            this.title = 'Skill ' + this.skillDetail.ID + ' - ' + this.skillDetail.Type + ' - ' + this.skillDetail.Name;
            this.details = {
              ID: this.skillDetail.ID,
              owner: this.owner,
              object: this.object,
              service: this.managerService,
              method: 'GetSkillAgents',
              priorities: this.priorities,
              persistence: this.persistence,
              roles: !this.securityService.validateGrant('ManageAssignments'),
              disable: this.disable,
            };
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  saveChanges() {
    const pl: any = {};
    const agents = [];
    const assignedAgents = this.assignAgentComponent.assignedDisplay;
    for (const group of assignedAgents) {
      for (const agent of group.options) {
        agents.push(agent.value + '|' + this.getPriorityValue(agent.label) + '|' + this.getPersistence(agent.label));
      }
    }
    pl.agents = agents;
    pl.id = this.skillDetail.ID;
    pl.enabled = this.skillDetail.Enabled;
    this.managerService
      .EditSkillDetails(pl)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditSkillDetails');
          if (isValid) {
            this.location.back();
          }
        })
      )
      .subscribe();
  }

  goBack() {
    this.location.back();
  }

  getPriorityValue(label: any) {
    const matchStart = ' - Priority ';
    if (label.lastIndexOf(matchStart) != -1) {
      label = label.substring(label.lastIndexOf(matchStart) + matchStart.length);
      return parseInt(label.split(' ')[0]);
    } else return 0;
  }

  getPersistence(label: any) {
    return label.lastIndexOf(' - Temporary') == -1;
  }
}
